import { useCallback } from "react";
import Icon, { IconId } from "domains/ui/components/Icon";
import { useWindowSize } from "domains/ui/hooks/useWindowSize";
import { AnalyticsEvents } from "infra/analytics/constants/Events";
import Track from "infra/analytics/Track";
import { FaInstagram, FaLinkedin, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

import { Box, HStack, Link, Text } from "@chakra-ui/react";

export const FOOTER_HEIGHT = 50;
type SOCIAL_ICON = "instagram" | "youtube" | "linkedin" | "twitter";

export default function Footer() {
  const { width: windowWidth } = useWindowSize();

  return (
    <>
      <Box flexGrow={1} />
      <HStack
        pos="relative"
        align="center"
        justify="space-between"
        w="100%"
        h={`${FOOTER_HEIGHT}px`}
        px={4}
        borderTopWidth="1px"
        bgColor="black.500"
      >
        <iframe
          style={{
            colorScheme: "none",
            borderRadius: "8px",
          }}
          src="https://status.scenario.com/badge?theme=dark"
          width={(windowWidth ?? 999) < 550 ? "26" : "250"}
          height="30"
          frameBorder="0"
          scrolling="no"
        />
        <HStack align="center" justify="center" spacing={4}>
          <FooterLink
            href="https://trust.scenario.com/"
            label="Trust Center"
            icon="Ui/Shield"
          />
          <Text size="body.md">|</Text>
          <FooterLink
            href="https://www.instagram.com/scenarioai"
            icon="instagram"
          />
          <FooterLink
            href="https://www.youtube.com/@scenario_gg"
            icon="youtube"
          />
          <FooterLink href="https://twitter.com/Scenario_gg" icon="twitter" />
          <FooterLink
            href="https://www.linkedin.com/company/scenario-com/"
            icon="linkedin"
          />
        </HStack>
      </HStack>
    </>
  );
}

function FooterIcon({ icon }: { icon: IconId | SOCIAL_ICON }) {
  switch (icon) {
    case "instagram":
      return <FaInstagram />;
    case "youtube":
      return <FaYoutube />;
    case "linkedin":
      return <FaLinkedin />;
    case "twitter":
      return <FaXTwitter />;
    default:
      return <Icon id={icon} h="16px" />;
  }
}

function FooterLink({
  href,
  label,
  icon,
}: {
  href: string;
  label?: string;
  icon: IconId | SOCIAL_ICON;
}) {
  const handleSocialLinkClick = useCallback(() => {
    Track(AnalyticsEvents.Footer.ClickedLink, { href, label });
  }, [href, label]);

  return (
    <Link href={href} isExternal onClick={handleSocialLinkClick}>
      <HStack align="center" spacing={2}>
        <FooterIcon icon={icon} />
        {!!label && (
          // Text will be hidden on mobile if the component can't be displayed
          <Text display={{ base: "none", md: "block" }} ml={1} size="body.md">
            {label}
          </Text>
        )}
      </HStack>
    </Link>
  );
}
